import { formatEntityName, formatFieldName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const setDefaultColumnStmtInstruction = `
#### Set default column value

- Syntax: \`default column <entity_name>.<column_name> <default_value>;\`
- Example: \`default column Article.createdAt now;\`
`;
export const stmtSetDefaultColumn = ({ entityName, columnName, defaultValue }) => {
    return `default column ${entityName}.${columnName} ${defaultValue};`;
};
export const stmtForHumanSetDefaultColumn = ({ entityName, columnName, defaultValue, }) => {
    return `Set the default value of the column __${columnName}__ in the database table __${entityName}__ to __${defaultValue}__.`;
};
export const setDefaultColumnHandler = createSchemaStatementHandler({
    type: 'default column',
    parse: line => {
        const match = /^default column (?<entityName>\w+)\.(?<columnName>\w+) (?<defaultValue>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'default column',
                entityName: formatEntityName(match.groups.entityName),
                columnName: formatFieldName(match.groups.columnName),
                defaultValue: parseDefaultValue(match.groups.defaultValue),
            }
            : null;
    },
    getHumanStmt: stmtForHumanSetDefaultColumn,
    apply: (stmt, builder) => {
        builder.updateSchema(it => it.updateColumnDefault(stmt.entityName, stmt.columnName, stmt.defaultValue));
    },
});
const parseDefaultValue = (value) => {
    switch (value) {
        case 'true':
            return true;
        case 'false':
            return false;
        case 'null':
            return null;
        case 'undefined':
            return undefined;
    }
    const numberValue = Number(value);
    if (!Number.isNaN(numberValue)) {
        return numberValue;
    }
    return value;
};
//# sourceMappingURL=SetDefaultColumnStmt.js.map